import _ from "lodash";
import i18n from "i18next";

export const getCustomErrorMessage = (err) => {
  const errorStatus = _.get(err, "status", "");
  switch (errorStatus) {
    case 500:
    case 400:
    case 401: {
      return i18n.t(
        "Sorry, Unable to process the request. Please try again after some time"
      );
    }
    case 200: {
      return err.message;
    }
    default: {
      return i18n.t("Oops!, something went wrong");
    }
  }
};
